// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"a8b51c04","109":"7793c8d4","118":"7c978fe6","663":"e215f881","811":"08faf0d7","982":"8f5d4f7b"}[chunkId] + ".chunk.js";
};